export default "__VITE_ASSET__v7KpKn3X__"